'use es6';

import { formatToReferencesList } from 'reference-resolvers/lib/formatReferences';
export const formatSharedTaskQueuesResponse = response => ({
  count: response.total || 0,
  hasMore: response.hasMore || false,
  offset: response.offset || 0,
  results: formatToReferencesList({
    getId: queue => queue.id,
    getLabel: queue => queue.name
  })(response.results)
});